export default "__VITE_ASSET__BptD5gDo__"